<ion-content class="hide-content-scroll">
  <ion-list class="hide-content-scroll" id="virtual-scroll-list">
    <app-list-item *ngFor="let item of listItems" [item]="item" ($change)="emitSelectedElement.emit($event)"></app-list-item>
  </ion-list>

  <ion-infinite-scroll threshold="40%" (ionInfinite)="loadData($event)">
    <ion-infinite-scroll-content loadingSpinner="bubbles"> </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
